<div data-bs-spy="scroll" data-bs-target="#navbar-example2" data-bs-offset="10" tabindex="0">
  <!-- header -->
  <app-header></app-header>
  <!-- end header -->
  <main id="mainContent" tabindex="-1">

    <!-- whatsapp -->
    <app-whatsapp></app-whatsapp>
    <!-- end wahtsApp -->
    <section class="pb-5 position-relative">
      <div class="position-relative faculty-hero d-flex">
        <div class="slid-img position-absolute w-100 h-100 top-0 start-0 overflow-hidden">
          <img class="position-absolute" src="{{faculty_image}}" alt="" />
          <div class="black-layer position-absolute top-0 start-0 h-100 w-100"></div>
        </div>
        <div class="position-relative d-flex align-items-lg-end justify-content-center institute-pref flex-column">
          <div class="blend-darken-bg position-absolute top-0 start-0 h-100 w-100"></div>
          <div class="pref position-relative text-white pe-lg-5 pe-3 ms-3 animate__animated animate__slideInRight wow">
            <h1 class="heading-font d-inline-block pt-5">
              <label class="d-block text-sm-end">{{DATE_ESTABLISH}}</label>
              {{FACULTY_NAME}}
            </h1>
          </div>
        </div>
        <div class="position-absolute start-0 bottom-0 container-fluid">
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb animate__animated animate__fadeInDown">
              <li class="breadcrumb-item">
                <a class="text-white">أكادميه الفنون</a>
              </li>
              <li class="breadcrumb-item">
                <a class="text-white" href="faculty.html">
                  {{FACULTY_NAME}}
                </a>
              </li>
              <!-- <li class="breadcrumb-item active" aria-current="page">
                القبول والتسجيل
              </li> -->
            </ol>
          </nav>
        </div>
      </div>
    </section>

    <section class="container-fluid">
      <!--About-->
      <div class="row py-5">
        <div class="col-xl-8 col-lg-10 mx-auto">
          <h3
            class="text-center heading-font heading-style mb-4 fw-normal animate__animated animate__fadeInUp animate__faster wow">
            نبذة عن المعهد
          </h3>
          <p class="fs-5 fw-medium mb-5 animate__animated animate__fadeInUp animate__fast wow">
            {{aboutFaculty}}
          </p>

          <div class="icon_social text-center">
            <!-- <a [href]="bank" target="_blank">
              <img src="assets/icon/bank-building.png" alt="بنك المعرفة">
            </a> -->
            <a [href]="facultyObj?.faculty_INSTAGRAME" target="_blank">
              <img src="assets/icon/instagram.png" alt="إنستغرام">
            </a>
            <a [href]="facultyObj?.faculty_TWITTER" target="_blank">
              <img src="assets/icon/twitter.png" alt="تويتر">
            </a>
            <a [href]="facultyObj?.faculty_YOUTUEB" target="_blank">
              <img src="assets/icon/social.png" alt="يوتيوب">
            </a>
            <a [href]="facultyObj?.faculty_FACEBOOK" target="_blank">
              <img src="assets/icon/facebook-app-symbol.png" alt="فيسبوك">
            </a>
          </div>
          <!--JOIN ROW-->
          <!-- <div class="join-now mb-5 row align-items-center animate__animated animate__fadeInUp wow">
            <div class="col col-xl-6">
              <a class="btn btn-primary text-white d-flex align-items-center text-start py-3 px-4 fs-6">
                <div class="flex-fill pe-3">
                  انضم إلى العام الدراسي الجديد في سبتمبر
                  <span class="d-block fw-bold pt-1"> سجل الان </span>
                </div>
                <i class="icon-arrow-sm default d-block overflow-hidden"></i>
              </a>
            </div>
            <label class="text-gray fs-5 fw-medium ps-4 col-auto d-none d-md-block">
              متبقي 27 يوم فقط للتسجيل !
            </label>
          </div> -->
          <!--END JOIN ROW-->
          <!-- <div class="row">
            <div
              class="col-lg-4 col-md-6 mb-lg-0 mb-3 pb-lg-0 pb-3 animate__animated animate__fadeInUp animate__faster wow">
              <a class="btn btn-link caption border border-primary d-flex align-items-center text-start p-3 fs-6 h-100">
                <div class="fw-medium flex-fill p-1">
                  دراسة البكالوريوس
                  <p class="mb-0 text-gray mt-1">4 سنوات فقط تفصلك عن حلمك</p>
                </div>
                <i class="icon-arrow-sm m-1 default d-block overflow-hidden"></i>
              </a>
            </div>
            <div
              class="col-lg-4 col-md-6 mb-lg-0 mb-3 pb-lg-0 pb-3 animate__animated animate__fadeInUp animate__fast wow">
              <a class="btn btn-link caption border border-primary d-flex align-items-center text-start p-3 fs-6 h-100">
                <div class="fw-medium flex-fill p-1">
                  الدراسات العليا
                  <p class="mb-0 text-gray mt-1">
                    كن من مطوري السينما و التلفزة
                  </p>
                </div>
                <i class="icon-arrow-sm m-1 default d-block overflow-hidden"></i>
              </a>
            </div>
            <div class="col-lg-4 col-md-6 mb-lg-0 mb-3 pb-lg-0 pb-3 animate__animated animate__fadeInUp wow">
              <a class="btn btn-link caption border border-primary d-flex align-items-center text-start p-3 fs-6 h-100">
                <div class="fw-medium flex-fill p-1">
                  الدراسات الحرة
                  <p class="mb-0 text-gray mt-1">أثقل مهاراتك بشكل إحترافي</p>
                </div>
                <i class="icon-arrow-sm m-1 default d-block overflow-hidden"></i>
              </a>
            </div>
          </div> -->
        </div>
      </div>
      <!--Actions-->
      <div class="row pt-5 pb-lg-5 pb-3">
        <div
          class="col-lg-6 col-md-6 mb-lg-0 mb-3 pb-lg-0 pb-3 animate__animated animate__fadeInUp animate__faster wow">
          <div class="card h-100">
            <div class="card-body">
              <h5 class="card-title fs-4 mt-2 fw-medium">أقسام المعهد</h5>
              <p class="card-subtitle mb-3 pb-3 text-gray border-bottom">
                يضم المعهد {{departments.length}} أقسام
              </p>
              <ul class="list-unstyled custom-styled ps-4 mb-3">
                <li *ngFor="let item of departments">
                  <a (click)="goto_depart(item)"
                  class="fw-medium fs-6 text-black link-list" role="button" tabindex="0" (keydown.enter)="goto_depart(item)" (keydown.space)="goto_depart(item)">{{item.TITLE}}</a>
                </li>
              </ul>

              <!-- <a class="btn btn-secondary mb-4 fs-5">
                التفاصيل
                <i class="icon-arrow-sm default"></i>
              </a> -->
            </div>
          </div>
        </div>
        <div class="col-lg-6 col-md-6 mb-lg-0 mb-3 pb-lg-0 pb-3 animate__animated animate__fadeInUp animate__fast wow">
          <div class="card h-100">
            <div class="card-body">
              <h5 class="card-title fs-4 mt-2 fw-medium">
                الانظمة التعليمية
              </h5>
              <p class="card-subtitle mb-3 pb-3 text-gray border-bottom">
                يتبع المعهد النظم التعليمية التابعه لأكادميه الفنون
              </p>
              <ul class="list-unstyled custom-styled ps-4 mb-3">
                <li (click)="faculty_fees('false')" role="button" tabindex="0" (keydown.enter)="faculty_fees('false')" (keydown.space)="faculty_fees('false')">
                  <a class="fw-medium fs-6 text-black link-list d-block">
                    التعليم النظامى
                    <p class="mb-0 caption fw-normal mb-2 pb-2">
                      تدعمه الحكومة المصرية مثله مثل أي جامعة مصرية
                    </p>
                  </a>
                </li>
                <li *ngIf="has_credit" (click)="faculty_fees('true')" role="button" tabindex="0" (keydown.enter)="faculty_fees('true')" (keydown.space)="faculty_fees('true')">
                  <a class="fw-medium fs-6 text-black link-list d-block">
                    لتعليم الموازي بمصروفات
                    <p class="mb-0 caption fw-normal mb-2 pb-2">
                      يقوم الطالب فيه بدفع مصروفات تعليمه كاملة
                    </p>
                  </a>
                </li>
                <!-- <li>
                  <a class="fw-medium fs-6 text-black link-list d-block">
                    الدراسات الحرة
                    <p class="mb-0 caption fw-normal mb-2 pb-2">
                      نظام تعليمي حر مسائي على هيئة دورات متتالية
                    </p>
                  </a>
                </li> -->
              </ul>

              <!-- <a class="btn btn-secondary mb-4 fs-5">
                تعرف أكثر
                <i class="icon-arrow-sm default"></i>
              </a> -->
            </div>
          </div>
        </div>
      </div>

    </section>

    <!-- News grid -->
    <section class="py-5 mb-5 news-container">
      <div class="container-fluid news-inner">
        <div class="news-head d-flex justify-content-between align-items-center flex-wrap">
          <div class="news-head-title d-flex align-items-center animate__animated animate__fadeInUp wow">
            <span class="news-head-accent"></span>
            <h2 class="heading-font fw-bold mb-0">أخبار {{FACULTY_NAME}}</h2>
          </div>
          <a [routerLink]="['/faculty_news_listing',facultyId]"
            class="news-head-link fw-bold animate__animated animate__fadeInDown wow">
            كل الأخبار
            <i class="icon-arrow-sm"></i>
          </a>
        </div>

        <div class="news-grid">
          <a (click)="newsDetails(item.ID)" class="news-card animate__animated animate__fadeInUp wow"
            *ngFor="let item of news" role="button" tabindex="0" (keydown.enter)="newsDetails(item.ID)" (keydown.space)="newsDetails(item.ID)">
            <div class="news-card-media overflow-hidden">
              <img class="news-card-img" src="{{item.IMG_PATH}}" alt="">
              <span class="news-card-date">{{item.NEW_DATE | date : "yyyy/MM/dd"}}</span>
            </div>
            <div class="news-card-body">
              <h3 class="news-card-title heading-font">{{item.TITLE}}</h3>
              <span class="news-card-more">اقرأ المزيد <i class="icon-arrow-sm"></i></span>
            </div>
          </a>
        </div>
      </div>
    </section>
    <!-- END News grid -->

    <!-- events -->
    <section class="py-5 mb-5 events-container">
      <div class="container-fluid events-inner">
        <div class="events-head d-flex justify-content-between align-items-center flex-wrap">
          <div class="events-head-title d-flex align-items-center animate__animated animate__fadeInUp wow">
            <span class="events-head-accent"></span>
            <h2 class="heading-font fw-bold mb-0">فعاليات {{FACULTY_NAME}}</h2>
          </div>
          <a [routerLink]="['/faculty_Events',facultyId]"
            class="events-head-link fw-bold animate__animated animate__fadeInDown wow">
            كل الفعاليات
            <i class="icon-arrow-sm"></i>
          </a>
        </div>

        <swiper [config]="eventConfig" class="swiper eventSwiper">
          <div class="swiper-wrapper">
            <div class="swiper-slide event-slide" *ngFor="let item of events">
              <a (click)="go_to_event(item)" class="event-card animate__animated animate__fadeInUp wow" role="button" tabindex="0" (keydown.enter)="go_to_event(item)" (keydown.space)="go_to_event(item)">
                <img class="event-card-img" src="{{item.IMG_PATH}}" alt="">
                <span class="event-card-badge">
                  <span class="event-card-day">{{item.START_DATE | date:'dd'}}</span>
                  <span class="event-card-month">{{item.START_DATE | date:'MM/yyyy'}}</span>
                </span>
                <div class="event-card-overlay">
                  <span class="event-card-faculty" *ngIf="item.FACULTY_NAME">{{item.FACULTY_NAME}}</span>
                  <h4 class="event-card-title heading-font">{{item.TITLE}}</h4>
                  <span class="event-card-more">اعرف التفاصيل <i class="icon-arrow-sm"></i></span>
                </div>
              </a>
            </div>
          </div>
          <div class="swiper-pagination events-pagination"></div>
        </swiper>
      </div>
    </section>
    <!-- END events -->

    <!-- gallrey -->
    <section class="py-5 mb-5 gallery-container">
      <div class="container-fluid gallery-inner">
        <div class="gallery-head d-flex justify-content-between align-items-center flex-wrap">
          <div class="gallery-head-title d-flex align-items-center animate__animated animate__fadeInUp wow">
            <span class="gallery-head-accent"></span>
            <h2 class="heading-font fw-bold mb-0">معرض الصور</h2>
          </div>
        </div>

        <swiper *ngIf="gallery?.length" [config]="galleryConfig" (click)="onGalleryClick($event)"
          class="swiper gallerySwiper">
          <div class="swiper-wrapper">
            <div class="swiper-slide gallery-slide" *ngFor="let item of gallery">
              <div class="gallery-card animate__animated animate__fadeInUp wow"
                data-bs-toggle="modal" data-bs-target="#imagePoup">
                <img class="gallery-card-img" [src]="item.image_path" alt="">
                <span class="gallery-card-overlay">
                  <span class="gallery-card-icon"><i class="icon-search"></i></span>
                </span>
              </div>
            </div>
          </div>
          <div class="swiper-pagination gallery-pagination"></div>
        </swiper>
      </div>
    </section>

    <div class="modal fade gallery-image-modal" id="imagePoup" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-xl modal-dialog-centered">
        <div class="modal-content">
          <button type="button" class="gallery-image-close" data-bs-dismiss="modal" aria-label="إغلاق">
            <span aria-hidden="true">&times;</span>
          </button>
          <div class="modal-body p-0">
            <img class="w-100" [src]="src_image" alt="صورة">
          </div>
        </div>
      </div>
    </div>
    <!-- END gallrey -->
    <!-- <section class="container-fluid pt-5 pt-5 pb-lg-5 pb-3">
      <div class="row">
        <div
          class="col-lg-3 col-md-6 mb-lg-0 mb-3 pb-lg-0 pb-3 animate__animated animate__fadeInUp animate__faster wow">
          <a class="btn caption border d-flex align-items-center text-start p-3 fs-6 h-100">
            <div class="fw-medium flex-fill p-1">
              موقع الطالب
              <p class="mb-0 text-gray mt-1">
                تعرف على المواد و المهام و النتيجة
              </p>
            </div>
            <i class="icon-arrow-sm m-1 default d-block overflow-hidden"></i>
          </a>
        </div>
        <div class="col-lg-3 col-md-6 mb-lg-0 mb-3 pb-lg-0 pb-3 animate__animated animate__fadeInUp animate__fast wow">
          <a class="btn caption border d-flex align-items-center text-start p-3 fs-6 h-100">
            <div class="fw-medium flex-fill p-1">
              موقع هيئة التدريس
              <p class="mb-0 text-gray mt-1">تابع متطلبات الطلبه</p>
            </div>
            <i class="icon-arrow-sm m-1 default d-block overflow-hidden"></i>
          </a>
        </div>
        <div class="col-lg-3 col-md-6 mb-lg-0 mb-3 pb-lg-0 pb-3 animate__animated animate__fadeInUp animate__fast wow">
          <a class="btn caption border d-flex align-items-center text-start p-3 fs-6 h-100">
            <div class="fw-medium flex-fill p-1">
              موقع الموظفين
              <p class="mb-0 text-gray mt-1">تابع متطلبات الطلبه</p>
            </div>
            <i class="icon-arrow-sm m-1 default d-block overflow-hidden"></i>
          </a>
        </div>
        <div class="col-lg-3 col-md-6 mb-lg-0 mb-3 pb-lg-0 pb-3 animate__animated animate__fadeInUp wow">
          <a class="btn caption border d-flex align-items-center text-start p-3 fs-6 h-100">
            <div class="fw-medium flex-fill p-1">
              خدمات الخريجين
              <p class="mb-0 text-gray mt-1">
                تعرف على الخدمات الخاصه بالخرجين
              </p>
            </div>
            <i class="icon-arrow-sm m-1 default d-block overflow-hidden"></i>
          </a>
        </div>
      </div>
    </section> -->
  </main>
  <!-- <app-footer></app-footer> -->

</div>